const Form = require('@ordergroove/brandy/src/app/forms/form');

class PaymentFormController extends Form {
  static get $inject() {
    return ['ccTypes'];
  }

  constructor(ccTypes) {
    super();

    this.ccTypes = ccTypes;
  }

  $onInit() {
    this.model.ccType = this.model.ccType || 1;
  }
}


angular.module('msi.payments.form')
  .controller('PaymentFormController', PaymentFormController);

module.exports = PaymentFormController;
